import { guideArticles } from '@/pages/home/data';

export default function GuideGrid() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.24em] text-secondary-700">GUIDE &amp; TIPS</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              图文攻略精选
            </h2>
          </div>
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 self-start md:self-auto text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
          >
            更多问题解答
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {guideArticles.map((article) => (
            <article
              key={article.title}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[8/5] w-full overflow-hidden bg-background-100">
                <img
                  src={article.cover}
                  alt={`${article.title} 配图`}
                  title={`${article.title} 蘑菇视频下载安装攻略`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 font-medium">
                  {article.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-base leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{article.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600 group-hover:gap-2 transition-all">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}